// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__c78dJ"};